module.exports = __webpack_public_path__ + "static/media/post2.c043abe1.PNG";